import React, { useEffect, useMemo } from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import { connect } from 'react-redux'
import { getLereLocationSeededYmalOffers } from 'selectors/recommendations'
import PaneBody from 'components/Common/Pane/PaneBody'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import { fetchDlpYmalRecommendations } from 'actions/RecommendationActions'
import { getListName } from 'analytics/enhanced-ecommerce'
import { useAppDispatch } from 'hooks/reduxHooks'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { ALL_GRAPH_RECOMMENDATION_OFFER_TYPES } from 'constants/recommendations'

interface OwnProps {
  destinationId: string;
  placeName: string;
}

interface Props extends OwnProps {
  analyticPageSource: string;
  isLoading: boolean;
  lereVersion: string | undefined;
  offerIds: Array<string>;
}

function LocationSeededYmalList(props: Props) {
  const { offerIds, destinationId, placeName, lereVersion } = props

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchDlpYmalRecommendations(destinationId))
  }, [dispatch, destinationId])

  const listName = getListName('LERE', props.analyticPageSource, 'Location Seeded YMAL')
  const tracking = useOfferListTracking(
    listName,
    {
      source: lereVersion ?? undefined,
      ga: {
        label: listName,
        category: 'Recommendations',
      },
    },
  )

  const offerList = useMemo<App.OfferList>(() => ({
    offerIds,
    fetching: false,
    key: tracking.listName,
  }), [offerIds, tracking.listName])

  if (offerIds.length === 0) {
    return null
  }

  return (
    <OfferListEventsProvider tracking={tracking}>
      <Pane>
        <PaneBody size="xl-y">
          <VerticalSpacer gap={16}>
            <LayoutContainer>
              <Heading variant="heading3">You may also like these deals outside {placeName}</Heading>
            </LayoutContainer>
            <OfferListCarousel overrideOfferList={offerList} />
          </VerticalSpacer>
        </PaneBody>
      </Pane>
    </OfferListEventsProvider>
  )
}

function mapStateToProps(state: App.State, ownProps: OwnProps) {
  const { offerIds, loadingState } = getLereLocationSeededYmalOffers(state, ownProps.destinationId, ALL_GRAPH_RECOMMENDATION_OFFER_TYPES)
  return {
    isLoading: loadingState === 'loading',
    lereVersion: state.recommendations.lereVersion,
    offerIds,
  }
}

export default connect(mapStateToProps)(LocationSeededYmalList)
